import axios from '../axios-marketplace';

const getAcessosPorDia = (params) => axios.get('/fornecedor/dashboard-acessos-ofertas/accessos-totais-dia', { params });
const getAcessosTotaisOferta = (params) => axios.get('/fornecedor/dashboard-acessos-ofertas/accessos-totais', { params });
const getAcessosUsuariosUnicosPorDia = (params) => axios.get('/fornecedor/dashboard-usuarios-unicos/accessos-totais-dia', { params });
const getAcessosFornecedorPorDia = (params) => axios.get('/fornecedor/dashboard-acessos-fornecedores/accessos-totais-dia', { params });
const getAcessosTotaisFornecedor = (params) => axios.get('/fornecedor/dashboard-acessos-fornecedores/accessos-totais', { params });

const getOfertasAcessadas = (params) => axios.get('/fornecedor/dashboard-acessos-ofertas/mais-acessadas', {
  params,
});

const getAcessosCategoria = (params) => axios.get('/fornecedor/dashboard-acessos-ofertas/categorias', {
  params,
});

export default {
  getAcessosPorDia,
  getAcessosTotaisOferta,
  getAcessosFornecedorPorDia,
  getAcessosTotaisFornecedor,
  getOfertasAcessadas,
  getAcessosCategoria,
  getAcessosUsuariosUnicosPorDia,
};
